<template>
  <v-app class="custom__bg mt-1">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8">
          <div class="mb-6 mt-2">
            <h2 style="font-size: 24px; font-weight: 700; color: #333">Settings</h2>
            <p class="grey--text text--darken-1 mb-0" style="font-size: 14px">Manage your account preferences and configurations</p>
          </div>

          <v-row>
            <!-- Settings Navigation Sidebar -->
            <v-col cols="12" md="4" class="mb-4">
              <v-card class="premium-card sticky-sidebar">
                <v-list class="pa-2" nav>
                  <v-list-item-group v-model="activeTab" color="#f69227">
                    <v-list-item v-for="(item, i) in menuItems" :key="i" class="rounded-lg mb-1" @click="scrollToSection(item.id)">
                      <v-list-item-icon class="mr-3">
                        <v-icon :color="activeTab === i ? '#f69227' : 'grey darken-1'">{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium" :style="{color: activeTab === i ? '#f69227' : '#555'}">
                          {{ item.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>

            <!-- Settings Content Area -->
            <v-col cols="12" md="8">
              
              <!-- Account Profile -->
              <v-card class="premium-card mb-6 animate-fadeInUp" id="account-section">
                <v-card-title class="py-4 px-5">
                  <span style="font-size: 18px; font-weight: 600">Account Profile</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-5">
                  <div class="d-flex align-center mb-6">
                    <div style="position: relative">
                      <v-avatar size="80" class="elevation-2" style="border: 3px solid white">
                        <img :src="$root.store.getUserAvatar()" alt="Profile" />
                      </v-avatar>
                      <v-btn icon small color="white" class="elevation-2" style="position: absolute; bottom: 0; right: -5px; background-color: #f69227">
                        <v-icon size="16">mdi-camera</v-icon>
                      </v-btn>
                    </div>
                    <div class="ml-5">
                      <v-btn outlined color="grey darken-1" class="text-capitalize mr-2 hover-scale" rounded small>Change Avatar</v-btn>
                      <v-btn text color="error" class="text-capitalize hover-scale" rounded small>Remove</v-btn>
                    </div>
                  </div>

                  <v-row>
                    <v-col cols="12" sm="6" class="py-1">
                      <p class="mb-1 font-weight-medium" style="font-size: 13px; color: #555">Full Name</p>
                      <v-text-field v-model="$root.storeState.currentUser.name" outlined dense rounded color="#f69227" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-1">
                      <p class="mb-1 font-weight-medium" style="font-size: 13px; color: #555">Email Address</p>
                      <v-text-field v-model="$root.storeState.currentUser.email" outlined dense rounded color="#f69227" hide-details type="email"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-1 mt-2">
                      <p class="mb-1 font-weight-medium" style="font-size: 13px; color: #555">University / School</p>
                      <v-text-field v-model="$root.storeState.currentUser.school" outlined dense rounded color="#f69227" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-1 mt-2">
                      <p class="mb-1 font-weight-medium" style="font-size: 13px; color: #555">Department / Major</p>
                      <v-text-field v-model="department" outlined dense rounded color="#f69227" hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" class="mt-4">
                      <v-btn color="#f69227" class="white--text text-capitalize px-6 hover-scale" rounded elevation="1" @click="saveProfile">
                        Save Changes
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Notifications -->
              <v-card class="premium-card mb-6 animate-fadeInUp delay-1" id="notifications-section">
                <v-card-title class="py-4 px-5">
                  <span style="font-size: 18px; font-weight: 600">Notifications</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-5">
                  <v-list class="pa-0">
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium" style="font-size: 15px">Email Notifications</v-list-item-title>
                        <v-list-item-subtitle style="font-size: 13px; color: #777">Receive updates about your account via email</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-switch v-model="notifs.email" color="#f69227" inset hide-details></v-switch>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider class="my-2"></v-divider>
                    
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium" style="font-size: 15px">Push Notifications</v-list-item-title>
                        <v-list-item-subtitle style="font-size: 13px; color: #777">Get notified directly in your browser</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-switch v-model="notifs.push" color="#f69227" inset hide-details></v-switch>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider class="my-2"></v-divider>

                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium" style="font-size: 15px">Quiz Reminders</v-list-item-title>
                        <v-list-item-subtitle style="font-size: 13px; color: #777">Daily reminders to take pending quizzes</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-switch v-model="notifs.quiz" color="#f69227" inset hide-details></v-switch>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>

              <!-- Privacy -->
              <v-card class="premium-card mb-6 animate-fadeInUp delay-2" id="privacy-section">
                <v-card-title class="py-4 px-5">
                  <span style="font-size: 18px; font-weight: 600">Privacy & Visibility</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-5">
                  <v-list class="pa-0">
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium" style="font-size: 15px">Public Profile</v-list-item-title>
                        <v-list-item-subtitle style="font-size: 13px; color: #777">Allow others to find your profile</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-switch v-model="privacy.public" color="#f69227" inset hide-details></v-switch>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider class="my-2"></v-divider>
                    
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium" style="font-size: 15px">Show Online Status</v-list-item-title>
                        <v-list-item-subtitle style="font-size: 13px; color: #777">Let connections see when you are active</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-switch v-model="privacy.online" color="#f69227" inset hide-details></v-switch>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
              
              <!-- Security / Password -->
              <v-card class="premium-card mb-6 animate-fadeInUp delay-3" id="security-section">
                <v-card-title class="py-4 px-5">
                  <span style="font-size: 18px; font-weight: 600">Security</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-5">
                  <v-form ref="passwordForm">
                    <v-row>
                      <v-col cols="12" class="py-1">
                        <p class="mb-1 font-weight-medium" style="font-size: 13px; color: #555">Current Password</p>
                        <v-text-field v-model="pass.current" type="password" outlined dense rounded color="#f69227" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-1 mt-2">
                        <p class="mb-1 font-weight-medium" style="font-size: 13px; color: #555">New Password</p>
                        <v-text-field v-model="pass.new" type="password" outlined dense rounded color="#f69227" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" class="py-1 mt-2">
                        <p class="mb-1 font-weight-medium" style="font-size: 13px; color: #555">Confirm New Password</p>
                        <v-text-field v-model="pass.confirm" type="password" outlined dense rounded color="#f69227" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <v-btn color="#333" class="white--text text-capitalize px-6 hover-scale" rounded elevation="1" @click="updatePassword">
                          Update Password
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>

              <!-- Danger Zone -->
              <v-card class="premium-card mb-10 animate-fadeInUp delay-4" id="danger-section" style="border: 1px solid #ffcdd2">
                <v-card-title class="py-4 px-5">
                  <span style="font-size: 18px; font-weight: 600; color: #ef5350">Danger Zone</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-5">
                  <div class="d-flex align-center justify-space-between flex-wrap">
                    <div class="mb-3 mb-sm-0 mr-4">
                      <h4 style="color: #333; font-size: 15px">Delete Account</h4>
                      <p class="caption grey--text text--darken-1 mx-0 mb-0 mt-1">Once you delete your account, there is no going back. All data will be lost.</p>
                    </div>
                    <v-btn outlined color="error" class="text-capitalize hover-scale" rounded @click="notAvailable('Account deletion')">
                      Delete Account
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>

            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    activeTab: 0,
    menuItems: [
      { title: 'Account Profile', icon: 'mdi-account-outline', id: 'account-section' },
      { title: 'Notifications', icon: 'mdi-bell-outline', id: 'notifications-section' },
      { title: 'Privacy', icon: 'mdi-shield-account-outline', id: 'privacy-section' },
      { title: 'Security', icon: 'mdi-lock-outline', id: 'security-section' },
      { title: 'Danger Zone', icon: 'mdi-alert-outline', id: 'danger-section' },
    ],
    department: 'Computer Science',
    notifs: {
      email: true,
      push: true,
      quiz: false
    },
    privacy: {
      public: true,
      online: true
    },
    pass: {
      current: '',
      new: '',
      confirm: ''
    }
  }),
  methods: {
    scrollToSection(id) {
      const el = document.getElementById(id);
      if (el) {
        window.scrollTo({
          top: el.offsetTop - 80,
          behavior: 'smooth'
        });
      }
    },
    saveProfile() {
      this.$root.store.save(); // save the v-model bound state
      this.saveSettings('Profile updated successfully');
    },
    saveSettings(msg) {
      this.$root.showSnackbar(msg, "#43a047", "mdi-check-circle");
    },
    updatePassword() {
      if (!this.pass.current || !this.pass.new) {
        this.$root.showSnackbar("Please fill in all password fields", "#ef5350", "mdi-alert-circle");
        return;
      }
      if (this.pass.new !== this.pass.confirm) {
        this.$root.showSnackbar("New passwords do not match", "#ef5350", "mdi-alert-circle");
        return;
      }
      
      this.pass.current = '';
      this.pass.new = '';
      this.pass.confirm = '';
      this.saveSettings("Password updated successfully");
    },
    notAvailable(feature) {
      this.$root.showSnackbar(`${feature} is not available at the moment.`, "#ef5350", "mdi-alert-circle");
    }
  }
};
</script>

<style scoped>
.custom__bg {
  background: #f5f5f5;
  min-height: 100vh;
}
.sticky-sidebar {
  position: sticky;
  top: 80px;
}
</style>
